/* import __COLOCATED_TEMPLATE__ from './awaiting-first-reply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();